import React from 'react';
import 'react-h5-audio-player/lib/styles.css';
import AudioPlayerLib from 'react-h5-audio-player';
import GetAppIcon from '@mui/icons-material/GetApp';

export const AudioPlayer = ({ url }) => {
    const handleDownload = (e) => {
        e.stopPropagation();
        const a = document.createElement("a");
        a.href = url;
        a.download = "audio.mp3";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <div dir="rtl" style={{ position: 'relative', fontFamily: 'IRANSans', width: '100%' }}>
            <AudioPlayerLib
                src={url}
                autoPlay={false}
                showJumpControls={false}
                customAdditionalControls={[]}
                customVolumeControls={[]}
                layout="horizontal"
                style={{
                    direction: 'rtl',
                    borderRadius: 8,
                    backgroundColor: '#fff',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    paddingRight: 48, // reserve space for the icon
                }}
            />
            <div style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 2
            }}>
                <GetAppIcon
                    onClick={handleDownload}
                    style={{ cursor: 'pointer', color: '#888' }}
                />
            </div>
        </div>
    );
};
